import React, { useEffect, useState, useRef } from 'react';
import { GameEngine } from '../game/GameEngine';
import { GameUI } from './GameUI';
import { MainMenu } from './MainMenu';
import { GameOver } from './GameOver';
export function Game() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const engineRef = useRef<GameEngine | null>(null);
  const [gameState, setGameState] = useState<'menu' | 'playing' | 'boss' | 'gameover' | 'victory'>('menu');
  const [stats, setStats] = useState({
    combo: 0,
    maxCombo: 0,
    score: 0
  });
  const [playerHealth, setPlayerHealth] = useState(100);
  const [bossHealth, setBossHealth] = useState(300);
  useEffect(() => {
    if (!canvasRef.current) return;
    const engine = new GameEngine(canvasRef.current);
    engineRef.current = engine;
    // Update UI state
    const updateInterval = setInterval(() => {
      if (engineRef.current) {
        const state = engineRef.current.getState();
        setGameState(state.gameState);
        setStats(state.stats);
        setPlayerHealth(state.player.health);
        setBossHealth(state.boss.health);
      }
    }, 100);
    return () => {
      clearInterval(updateInterval);
    };
  }, []);
  const handleStart = () => {
    if (engineRef.current) {
      engineRef.current.reset();
      engineRef.current.start();
    }
  };
  const handleBossFight = () => {
    if (engineRef.current) {
      engineRef.current.reset();
      engineRef.current.startBossFight();
    }
  };
  const handleRestart = () => {
    if (engineRef.current) {
      engineRef.current.reset();
      engineRef.current.setState('menu');
    }
  };
  return <div className="relative w-full h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-1">
      <canvas ref={canvasRef} width={800} height={600} className="border-4 border-purple-500/30 shadow-2xl" style={{
      imageRendering: 'pixelated',
      imageRendering: 'crisp-edges'
    }} data-id="element-2" />

      {gameState === 'menu' && <MainMenu onStart={handleStart} onBossFight={handleBossFight} data-id="element-3" />}

      {(gameState === 'playing' || gameState === 'boss') && <GameUI health={playerHealth} maxHealth={100} bossHealth={bossHealth} bossMaxHealth={300} combo={stats.combo} score={stats.score} showBoss={gameState === 'boss'} data-id="element-4" />}

      {(gameState === 'gameover' || gameState === 'victory') && <GameOver victory={gameState === 'victory'} score={stats.score} maxCombo={stats.maxCombo} onRestart={handleRestart} data-id="element-5" />}
    </div>;
}